import { ClassCast } from '@utilities/object-helper';
import { OfdmaScan } from './ofdma-scan';

export class OfdmaData {
  mac: string;
  timestamp: number;
  latitude: number;
  longitude: number;
  location: string;
  @ClassCast(OfdmaScan)
  ofdmaScans: OfdmaScan[];
}
